import {Navigate, Outlet, useLocation} from "react-router-dom";

import PageLoader from "../PageLoader";

import useAuth from "../../hooks/useAuth";

const PublicRoute = () => {
    const {isLogin, token} = useAuth();
    const location = useLocation();

    const fromPage = location.state?.from || "/dashboard";

    if(!isLogin && token) {
        return <PageLoader />
    }

    if(isLogin) {
        return <Navigate to={fromPage} />
    }

    return <Outlet />
}

export default PublicRoute;
